import Entity from '../entity'

export default class Agreement extends Entity<number>{
    zone_id: number;
    dealer_id: number;
    reason: string;
    state_id: number;
    level_id: number;
    description: string;
    days: number;
    agreement_date: string;
    due_date: string;
    notes: string;
    measures: string;
    filename: string;

    days_remain: number;
}


